import { Cell, Edge, Node } from "@antv/x6"
import { PanelType } from "./types"
import { CellPanel } from "./CellPanel/CellPanel"
import { AllUnitsPanel } from "./AllUnitsPanel/AllUnitsPanel"
import { SpreadsheetPanel } from "./UnitPanel/components/Spreadsheets/SpreadsheetPanel"
import { TemplateSetting } from "./TemplateSetting/TemplateSetting"
import { NodeSetting } from "./NodeSetting/NodeSetting"
import { NodeShapes } from "../../services/modal"
import { SimLogsPanel } from "./SimLogsPanel/SimLogsPanel"
import { PPSTPanel } from "./PPSTPanel/PPSTPanel"

interface RightPanelProps {
  type: PanelType
  cell: Cell | null
  onChange?: () => void
}

export function RightPanel(props: RightPanelProps) {
  const {type, cell, onChange} = props;

  switch (type) {
    case PanelType.Cell: {
      if (!cell) return null;
      return <CellPanel cell={cell} onChange={onChange} key={cell?.id} />
    }
    case PanelType.AllUnits: {
      return <AllUnitsPanel />
    }
    case PanelType.Graph: {
      if (!cell) return null;
      if ([NodeShapes.LineJump, NodeShapes.SvgNode, NodeShapes.TextNode].includes(cell.shape as NodeShapes)) {
        return <NodeSetting unit={cell as Node} key={cell?.id} />
      }
      if (cell.isEdge()) {
        return <NodeSetting unit={cell as Edge} key={cell?.id} />
      }
      return null;
    }
    case PanelType.Template: {
      return <TemplateSetting />
    }
    case PanelType.Spreadsheet: {
      return <SpreadsheetPanel onChange={onChange} />
    }
    case PanelType.SimLogs: {
      return <SimLogsPanel />
    }
    case PanelType.PPST: {
      return <PPSTPanel />
    }
    default: {
      return null
    }
  }
}